import React from 'react';
import c from 'classnames';
import CoreBadge from '../Badges/CoreBadge';
import s from './Logo.scss';
const Logo = ({ className, style, markColor = 'green', markColorClassname, textColor = 'black', textColorClassname, size = 'medium', withText = true, corePackage, coreClassName })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], s[`size-${size}`], s['new-core'], className),
        style: style
    }, /*#__PURE__*/ React.createElement("span", {
        className: c(s['mark'], s['mark-pride'])
    }, /*#__PURE__*/ React.createElement("svg", {
        width: "29",
        height: "49",
        viewBox: "0 0 29 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "plga",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "1",
        width: "29",
        height: "47"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M28.795 9.679V1.344h-8.398l-.839.84-3.962 7.495-1.246.836H.205v11.446h7.773l.695.833L.205 38.85v8.335h8.401l.84-.836 3.962-7.495 1.25-.837h14.137V26.572h-7.777l-.691-.836 8.468-16.057Z",
        fill: "#00E59B"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#plga)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FF4040",
        d: "M-5.793.265h37.242v8.224H-5.793z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF9C40",
        d: "M-5.793 4.615h37.242v8.224H-5.793z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFEC40",
        d: "M-5.793 8.965h37.242v8.224H-5.793z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#48E001",
        d: "M-5.793 13.315h37.242v8.224H-5.793z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#1C40FF",
        d: "M-5.793 17.666h37.242v8.224H-5.793z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B14EFF",
        d: "M-5.531 22.016h37.242v8.224H-5.531z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#393B42",
        d: "M-5.531 26.366h37.242v8.224H-5.531z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB8151",
        d: "M-5.531 30.716h37.242v8.224H-5.531z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#44D2FF",
        d: "M-5.531 35.066h37.242v8.224H-5.531z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFBEDE",
        d: "M-5.531 39.416h37.242v8.224H-5.531z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M-5.531 43.766h37.242v8.224H-5.531z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#plgb)",
        d: "M-9.653-1.697h45.245v54.119H-9.653z",
        style: {
            mixBlendMode: 'hard-light'
        },
        opacity: ".75"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#plgc)",
        d: "M-9.653-1.697h45.245v54.119H-9.653z",
        style: {
            mixBlendMode: 'hard-light'
        },
        opacity: ".45"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "plgb",
        x1: "-8.14",
        y1: "8.979",
        x2: "21.368",
        y2: "25.362",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#C4C4C4",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "plgc",
        x1: ".381",
        y1: "16.836",
        x2: "35.592",
        y2: "40.011",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#C4C4C4",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1"
    }))))), withText && /*#__PURE__*/ React.createElement("span", {
        className: c(s['text'], textColorClassname || s[`text-${textColor}`])
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "0",
        height: "0",
        viewBox: "0 0 74 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M59.7169 5.20574L56.3816 0.333496H53.4444V10.6192H56.4216V5.39556L60.1142 10.6192H62.6944V0.333496H59.7169V5.20574ZM47.6113 0.333496L42.1389 10.6189H45.3799L46.1767 9.12019H49.8391L50.2026 10.6189L53.4444 10.6192L50.9423 0.333496H47.6113ZM47.2778 7.19064L48.6837 4.90492L49.3333 7.19064H47.2778ZM63.7222 0.333496V3.06014H66.697V10.6192H68.4897L69.843 8.0891V3.06014H72.5413L74 0.333496H63.7222ZM31.4758 6.55813L29.9626 0.333496H26.7222L29.2235 10.6192H32.5569L38.0278 0.333496H34.7838L31.4758 6.55813ZM17.4722 10.6192H25.6944V7.89268H20.6915V6.78111H25.2913V4.17124H20.6915V3.06003H25.6944V0.333496H17.4722V10.6192ZM11.5743 0.333496L10.2194 2.97222H11.0514C12.5365 2.97222 13.4769 3.94093 13.4769 5.47324C13.4769 6.98761 12.5365 7.9565 11.0514 7.9565H10.1111V3.18313L7.19444 8.86409V10.6192H11.2525C14.5223 10.6192 16.4444 8.60752 16.4444 5.47307C16.4444 2.4422 14.6477 0.462136 11.5743 0.333496ZM38.0278 10.6192H41.1111V0.333496H38.0278V10.6192ZM20.5556 14.0478V16.7743H23.5303V24.3335H25.3229L26.6762 21.8033V16.7743H29.3743L30.8333 14.0478H20.5556ZM20.1464 17.7737C20.1464 15.4118 18.5263 14.0478 16.2485 14.0478H11.3056V24.3335H14.4261V21.3336H15.1853L15.8053 21.3318L17.3162 24.3335H20.5556L18.6293 20.7042C19.574 20.1107 20.1464 19.1049 20.1464 17.7737ZM15.5056 18.6192H14.3889V16.3335H15.5056C16.186 16.3335 16.4444 16.7907 16.4444 17.4854C16.4444 18.1624 16.186 18.6192 15.5056 18.6192ZM5.46632 14.0478L0 24.3335H3.24384L4.0369 22.8368L7.69963 22.8367L8.0619 24.3335H11.3056L8.80555 14.0478H5.46632ZM5.13889 19.7621L6.54533 17.4764L7.19444 19.7621H5.13889Z"
    }))), corePackage && withText && /*#__PURE__*/ React.createElement(CoreBadge, {
        size: "small",
        corePackage: corePackage,
        className: c(s['core'], coreClassName)
    }));
};
Logo.displayName = 'Logo';
export default Logo;
